const SET_KO_FILTER = 'SET_KO_FILTER';
const SET_AMOUNT = 'SET_AMOUNT';
const SET_DURATION = 'SET_DURATION';
export default {
	namespaced: true,
	state: {
		koFilter: null,
		amount: null,
		duration: null
	},
	actions: {
		setKoFilter({ commit }, koFilter) {
			commit(SET_KO_FILTER, koFilter);
		},
		setAmount({ commit }, amount) {
			commit(SET_AMOUNT, amount);
		},
		setDuration({ commit }, duration) {
			commit(SET_DURATION, duration);
		}
	},
	mutations: {
		[SET_KO_FILTER](state, koFilter) {
			state.koFilter = koFilter;
		},
		[SET_AMOUNT](state, amount) {
			state.amount = amount;
		},
		[SET_DURATION](state, duration) {
			state.duration = duration;
		}
	}
};
